export function previouslyUsedCards(methods, successfulIds, allowsDeletion) {
    const cards = new Map(fundingSavedCards(methods, allowsDeletion).map((card) => [card.id, card]));
    return [...new Set(successfulIds)].flatMap((id) => {
        const card = cards.get(id);
        return card ? [card] : [];
    });
}
/** Only cards returned by MoonPay are stored cards; an Add Card callback is not persistence. */
export function fundingSavedCards(methods, allowsDeletion) {
    const cards = new Map();
    for (const method of methods) {
        if (method.type !== 'card' || !('brand' in method))
            continue;
        cards.set(method.id, {
            id: method.id,
            brand: method.brand,
            last4: method.last4,
            cardType: method.cardType,
            expirationMonth: method.expirationMonth,
            expirationYear: method.expirationYear,
            availability: method.availability.active
                ? { active: true }
                : { active: false, reasons: method.availability.reasons ?? [] },
            allowsDeletion,
        });
    }
    return [...cards.values()];
}
